module.exports = __webpack_public_path__ + "static/media/logo_red_horizontal.5ca06d8e.png";